import PropTypes from 'prop-types';

import { Box, Paper, Skeleton, Stack } from '@mui/material';

const SectionSkeleton = ({ children }) => (
	<Paper
		variant='outlined'
		sx={{
			p: 3,
			borderRadius: 2,
		}}
	>
		{children}
	</Paper>
);

SectionSkeleton.propTypes = {
	children: PropTypes.node.isRequired,
};

const UserEmailSyncConfigSkeleton = () => {
	return (
		<Box
			data-testid='user-email-sync-config-skeleton'
			sx={{
				display: 'flex',
				flexDirection: 'column',
				gap: 2,
				width: '100%',
			}}
		>
			{/* Automatic Email Sync */}
			<SectionSkeleton>
				<Stack spacing={2.5}>
					<Box>
						<Skeleton variant='text' width={190} height={28} />
						<Skeleton variant='text' width='65%' height={20} />
					</Box>

					<Box
						sx={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'space-between',
						}}
					>
						<Box sx={{ flex: 1 }}>
							<Skeleton variant='text' width={160} height={24} />
							<Skeleton variant='text' width='55%' height={18} />
						</Box>

						<Skeleton variant='rounded' width={42} height={24} />
					</Box>

					<Box
						sx={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'space-between',
						}}
					>
						<Box sx={{ flex: 1 }}>
							<Skeleton variant='text' width={150} height={24} />
							<Skeleton variant='text' width='55%' height={18} />
						</Box>

						<Skeleton variant='rounded' width={42} height={24} />
					</Box>
				</Stack>
			</SectionSkeleton>

			{/* Basic Settings */}
			<SectionSkeleton>
				<Stack spacing={2.5}>
					<Box>
						<Skeleton variant='text' width={150} height={28} />
						<Skeleton variant='text' width='55%' height={20} />
					</Box>

					<Box
						sx={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'space-between',
						}}
					>
						<Box sx={{ flex: 1 }}>
							<Skeleton variant='text' width={170} height={24} />
							<Skeleton variant='text' width='60%' height={18} />
						</Box>

						<Skeleton variant='rounded' width={42} height={24} />
					</Box>

					<Box
						sx={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'space-between',
						}}
					>
						<Box sx={{ flex: 1 }}>
							<Skeleton variant='text' width={180} height={24} />
							<Skeleton variant='text' width='55%' height={18} />
						</Box>

						<Skeleton variant='rounded' width={42} height={24} />
					</Box>

					<Box>
						<Skeleton variant='text' width={190} height={24} />
						<Skeleton variant='text' width='65%' height={18} />

						<Box
							sx={{
								display: 'flex',
								gap: 1.5,
								mt: 1.5,
							}}
						>
							<Skeleton variant='rounded' width={140} height={40} />
							<Skeleton variant='rounded' width={130} height={40} />
						</Box>
					</Box>

					<Box>
						<Skeleton variant='text' width={175} height={24} />
						<Skeleton variant='text' width='60%' height={18} />
						<Skeleton
							variant='rounded'
							width='100%'
							height={40}
							sx={{ mt: 1.5 }}
						/>
					</Box>
				</Stack>
			</SectionSkeleton>

			{/* Email Rules */}
			<SectionSkeleton>
				<Stack spacing={2}>
					<Box>
						<Skeleton variant='text' width={130} height={28} />
						<Skeleton variant='text' width='65%' height={20} />
					</Box>

					<Box
						sx={{
							display: 'flex',
							gap: 1.5,
						}}
					>
						<Skeleton variant='rounded' width={160} height={40} />
						<Skeleton variant='rounded' sx={{ flex: 1 }} height={40} />
						<Skeleton variant='rounded' width={90} height={40} />
					</Box>

					<Stack spacing={1}>
						<Skeleton variant='rounded' width='100%' height={44} />
						<Skeleton variant='rounded' width='100%' height={44} />
					</Stack>
				</Stack>
			</SectionSkeleton>

			{/* Dynamic Domain List */}
			<SectionSkeleton>
				<Stack spacing={2}>
					<Box>
						<Skeleton variant='text' width={190} height={28} />
						<Skeleton variant='text' width='70%' height={20} />
					</Box>

					<Box
						sx={{
							display: 'flex',
							gap: 1.5,
						}}
					>
						<Skeleton variant='rounded' sx={{ flex: 1 }} height={40} />
						<Skeleton variant='rounded' width={110} height={40} />
					</Box>
				</Stack>
			</SectionSkeleton>
		</Box>
	);
};

export default UserEmailSyncConfigSkeleton;
